import ApiBase from '../ApiBase';

class Notifications extends ApiBase {
  /**
   * @method fetch
   * @param {number} page
   * @param {object} filters
   * @return {Promise<*>}
   */
  fetch = (page, filters = {}) => {
    return this.get('me/notifications', {
      page,
      ...filters,
    });
  };

  /**
   * @method read
   * @param {string} id
   * @return {Promise<boolean|{status: number}>}
   */
  read = (id) => {
    return this.patch('me/notifications/read', {
      ids: [id],
    }, 'read');
  };

  /**
   * @method readAll
   * @return {Promise<boolean|{status: number}>}
   */
  readAll = () => {
    return this.patch('me/notifications/read-all', {}, 'read');
  };
}

export default new Notifications();
